<div fxFlex.gt-sm="100" id="leave-type-filter">
    <mat-form-field floatLabel="never">
        <mat-label>Tipo de Baja</mat-label>
        <mat-select [formControl]="LeaveTypeControl" class="full-width-multi-select" multiple
            (ngModelChange)="SetLeaveType()">
            <mat-option *ngFor="let leaveType of leaveTypeOptions" [value]="leaveType.value">{{leaveType.text}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>